import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getWustlDoCM } from "../selectors/cancer-dbs.selectors";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";
import { getDiseasesTable } from "./DiseasesTable";
import { getDrugsTable } from "./DrugsTable";
import { getCardsUIEnabled } from "../../../../../state/selectors/CardsUI.selectors";

const { arrayOf, number, shape, string } = PropTypes;

const DoCM = ({ data, cardsUIEnabled }) => {
  const [collapsedAccordion, setCollapsedAccordion] = useState(false);

  const handleCollapseArrow = (isColapsed) => {
    if (cardsUIEnabled) {
      return null;
    }
    return isColapsed ? (
      <a
        className="varsome-right varsome-collapse-arrow no-underline no-print"
        title="Expand this box"
        onClick={() => setCollapsedAccordion(false)}
      >
        <span>OPEN</span>
        <i className="varsome-icons icon-chevron-down open" />
      </a>
    ) : (
      <a
        className="varsome-right varsome-collapse-arrow no-underline no-print"
        title="Collapse this box"
        onClick={() => setCollapsedAccordion(true)}
      >
        <span>CLOSE</span>
        <i className="varsome-icons icon-chevron-up" />
      </a>
    );
  };
  return (
    <>
      {data && (
        <div className="varsome-result">
          <div
            className={`varsome-container ${
              cardsUIEnabled ? "varsome-container__basic" : ""
            }`}
          >
            <div className="varsome-title varsome-clearfix">
              <a href={getVarsoUrl("http://docm.info/")} target="_blank">
                DoCM
              </a>
              <small>
                {" Version: "}
                <span>{data[0].version}</span>
              </small>
              {data && data.legth > 0 && data[0]?.hgvs && (
                <div className="varsome-right">
                  <small className="tw-mr-4">
                    <a
                      href={getVarsoUrl(
                        `http://docm.info/variants/${data[0].hgvs}`
                      )}
                      target="_blank"
                    >
                      View this on the DoCM site
                    </a>
                  </small>
                </div>
              )}
              {handleCollapseArrow(collapsedAccordion)}
            </div>
            <div className={collapsedAccordion ? "varsome-hidden" : ""}>
              <div className="varsome-inner-container">
                {data[0].diseases && (
                  <div>
                    <h5>Diseases</h5>
                    {getDiseasesTable(data[0].diseases)}
                  </div>
                )}
                {data[0].drugs && (
                  <div className="tw-mt-10">
                    <h5>Drugs</h5>
                    {getDrugsTable(data[0].drugs)}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  data: getWustlDoCM(state),
  cardsUIEnabled: getCardsUIEnabled(state),
});

DoCM.propTypes = {
  data: arrayOf(
    shape({
      version: string,
      diseases: arrayOf(
        shape({
          disease: string,
          doid: string,
          pub_med_references: arrayOf(number),
          tags: arrayOf(string),
        })
      ),
      drugs: arrayOf(
        shape({
          effect: string,
          evidence: string,
          pathway: string,
          source: string,
          status: string,
          therapeutic_context: string,
        })
      ),
    })
  ),
  cardsUIEnabled: PropTypes.bool,
};

DoCM.defaultProps = {
  data: null,
  cardsUIEnabled: false,
};

export default connect(mapStateToProps)(DoCM);
